import { Logger } from "../../../util/log/Logger";
import { MouseBlocker } from "../../control/MouseBlocker";
import { TitanSpine } from "../../control/TitanSpine";
import { SpineConstants } from "../../control/constant/ControlConstants";
import { MouseBlockerProperties } from "../../control/properties/MouseBlockerProperties";
import { SpineProperties } from "../../control/properties/SpineProperties";
import { AbstractView } from "../AbstractView";
import { FullScreenStyle, PreloaderStyle } from "../style/CommonStyle";
export class FullScreen extends AbstractView {
    constructor(manager) {
        super();
        this.register(manager);
        this.run();
    }
    register(manager) {
        this.manager = manager;
        this.manager.onOpen(this.handleOpen, this);
        this.manager.onExit(this.handleExit, this);
    }
    create() {
        super.create();
        this.started = false;
        this.createBlocker();
        this.spine = TitanSpine.createSpine(this, new SpineProperties(FullScreenStyle.FULL_SCREEN, PreloaderStyle.PRELOADER));
        this.start();
    }
    postCreate() {
        super.postCreate();
        Logger.addObjectRef(this, "FullScreen");
    }
    createBlocker() {
        this.blocker = new MouseBlocker(new MouseBlockerProperties(0x000000, 0.6, true));
        this.blocker.onClick(this.handleBlockerSelected, this);
    }
    start() {
        this.started = true;
        this.update();
    }
    update() {
        this.manager.isFullScreen() ? this.stop() : this.play();
    }
    stop() {
        this.spine.stop();
        this.hide();
    }
    play() {
        this.spine.play(SpineConstants.ANIMATION, true);
        this.show();
    }
    handleBlockerSelected() {
        this.manager.open();
    }
    handleOpen() {
        if (this.started) {
            this.stop();
        }
    }
    handleExit() {
        if (this.started) {
            this.play();
        }
    }
    hide() {
        if (this.blocker.parent === this) {
            this.removeChild(this.blocker);
        }
        super.hide();
    }
    show() {
        let rotated = this.renderer.getRotated();
        if (!rotated) {
            this.addChild(this.blocker);
            window.requestAnimationFrame(() => this.blocker.fitToWindow());
            super.show();
        }
    }
    handleResize() {
        let rotated = this.renderer.getRotated();
        if (!rotated) {
            let gameSize = this.renderer.getGameSize();
            let middleX = gameSize.x / 2;
            let middleY = gameSize.y / 2;
            this.spine.x = middleX;
            this.spine.y = middleY;
        }
        this.updateVisibility();
    }
    updateVisibility() {
        let rotated = this.renderer.getRotated();
        let fullScreen = this.manager.isFullScreen();
        if (rotated) {
            this.hide();
        }
        else {
            if (this.started) {
                if (fullScreen || rotated) {
                    this.hide();
                }
                else {
                    this.show();
                }
            }
        }
    }
}
//# sourceMappingURL=FullScreen.js.map